<template>
  <div v-if="kind === 'loading'" class="rcp-grid" style="--rcp-min: 510px" role="status" aria-busy="true">
    <span class="ui-sr">{{ $t("loading") }}</span>
    <section v-for="n in 4" :key="n" class="ui-card rcp-card rcp-card--skeleton" aria-hidden="true">
      <div class="rcp-card__head">
        <span class="ui-sk" style="width: 46%; height: 16px"></span>
        <span style="flex: 1"></span>
        <span class="ui-sk" style="width: 84px; height: 16px"></span>
      </div>
      <div v-for="row in 5" :key="row" class="rcp-skeleton-row">
        <span v-for="cell in 5" :key="cell" class="ui-sk"></span>
      </div>
    </section>
  </div>

  <div v-else-if="kind === 'error'" class="rcp-alert ui-banner ui-banner--lg" role="alert">
    <v-icon size="22" color="#7a1b13">mdi-alert-outline</v-icon>
    <div>
      <b>{{ $t("recipes_shell.error_title") }}</b>
      <span>{{ $t("recipes_shell.error_text") }}</span>
      <ui-button size="sm" icon="mdi-refresh" @click="ctl.retry">{{ $t("report_mobile.retry") }}</ui-button>
    </div>
  </div>

  <ui-state v-else kind="empty" lg :icon="icon" :title="title" :text="text">
    <div v-if="actions.length" class="rcp-state__actions">
      <ui-button v-for="action in actions" :key="action.key" size="sm" @click="action.run">{{ action.label }}</ui-button>
    </div>
  </ui-state>
</template>

<script>
/**
 * Stanja ekrana: učitavanje (skelet kartica), greška sa "Pokušaj ponovo", nema podataka za period i
 * "ništa ne odgovara" (nijedna smjena, nijedno jelo, pretraga bez pogotka, jela bez porcija) sa predlogom šta uraditi.
 */
export default {
  name: "RecipesState",
  inject: { ctl: "recipesCtl" },
  props: {
    kind: { type: String, required: true, validator: (value) => ["loading", "error", "nodata", "nomatch"].includes(value) },
  },
  computed: {
    reason() {
      if (this.kind === "nodata") {
        return "nodata";
      }
      if (!this.ctl.shifts.length) {
        return "shift";
      }
      if (!this.ctl.pickedCount) {
        return "meals";
      }
      if (this.ctl.search.trim()) {
        return "search";
      }
      return "portions";
    },
    icon() {
      return { nodata: "mdi-food-off", shift: "mdi-clock-outline", meals: "mdi-silverware-fork-knife", search: "mdi-magnify", portions: "mdi-clock-outline" }[this.reason];
    },
    title() {
      return this.$t(`recipes_shell.state.${this.reason}.title`);
    },
    text() {
      return this.$t(`recipes_shell.state.${this.reason}.text`, { q: this.ctl.search.trim() });
    },
    actions() {
      const ctl = this.ctl;
      const preset = (key) => {
        const found = ctl.presets.find((p) => p.key === key);
        return { key, label: this.$t(`report_mobile.presets.${key}`), run: () => ctl.setPeriod({ from: found.from, to: found.to }) };
      };
      switch (this.reason) {
        case "nodata": {
          const other = ctl.view === "meal" ? "group" : "meal";
          return [preset("tomorrow"), preset("this_week"), { key: "view", label: ctl.viewLabel(other), run: () => ctl.setView(other) }];
        }
        case "shift":
          return [{ key: "shift", label: this.$t("recipes_shell.state.shift.action"), run: () => ctl.setShifts([1]) }];
        case "meals":
          return [{ key: "meals", label: this.$t("recipes_shell.state.meals.action"), run: () => ctl.setAllMeals(true) }];
        case "search":
          return [{ key: "search", label: this.$t("recipes_shell.state.search.action"), run: () => ctl.setSearch("") }];
        default:
          return [{ key: "portions", label: this.$t("recipes_shell.state.portions.action"), run: () => ctl.setShifts([1, 2, 3, 4]) }];
      }
    },
  },
};
</script>
